import { getProductSEOImages } from '@otovo/shared/lib/sanity/getMetaImageUrl';
import { Sanity$Product } from '@otovo/shared/types/sanityTypes';

export const getProductSEOsnippets = (product: Sanity$Product) => {
  const images = getProductSEOImages(product.image);

  return JSON.stringify(
    {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: product.fullProductName,
      image: images,
      description: product.productDescription,
      sku: product.sku,
      mpn: product.manufacturerPartNumber,
      brand: {
        '@type': 'Brand',
        name: product.brand,
      },
      review: {
        '@type': 'Review',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: product.authorRating,
          bestRating: product.highestPossibleRating,
        },
        author: {
          '@type': 'Person',
          name: product.author,
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: product.publicRating,
        reviewCount: product.numberOfPublicRatings,
      },
      offers: {
        '@type': 'AggregateOffer',
        offerCount: 1,
        lowPrice: product.buyNowValueLowest,
        highPrice: product.buyNowValueHighest,
        priceCurrency: 'EUR',
      },
    },
    null,
    4,
  );
};
